import { useEffect, useState } from "react";
import EditPartnerForm from "./editPartner";
import PartnerDataPopup from "./PartnerDataPopup";
import TableFilter from "./TableFilter";
import { Pagination, Table } from "antd";
import config from "../../../config";
import styles from "./styles/Partners.module.css";
import dayjs from "dayjs";
const base_url = config.base_url;

function PartnersDataTable({
  openAddNewPartner,
  setOpenAddNewPartner,
  closeAddPartnerModal,
}) {
  const [popupData, setPopupData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [globalSearch, setGlobalSearch] = useState("");
  const [modalOpened, setModalOpened] = useState(false);
  const [userId, setUserId] = useState(null);
  const [openEditPartnerModal, setOpenEditPartnerModal] = useState(false);
  const [tableLoading, setTableLoading] = useState(true);
  const [data, setData] = useState([]);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(50);
  const columns = [
    // eslint-disable-next-line react-hooks/exhaustive-deps
    {
      key: "1",
      title: "Partner Name",
      dataIndex: "name",
      sorter: (a, b) => {
        return a.name.localeCompare(b.name);
      },

      //   onFilter: (value, record) => {
      //     return record.partner_name.includes(value);
      //   },
      render: (text, record, index) => {
        return (
          <p
            data-openpopup={"no"}
            onClick={(e) => {
              setUserId(record.user_id);
              setOpenEditPartnerModal(true);
            }}
          >
            <span data-openpopup={"no"}>{record.index}.&nbsp;&nbsp;&nbsp;</span>
            <span
              data-openpopup={"no"}
              style={{
                textDecoration: "underline",
                color: "rgb(0, 145, 234)",
                maxWidth: "170px",
                display: "inline-block",
              }}
            >
              {text}
            </span>
          </p>
        );
      },
    },
    {
      key: "2",
      title: "Partner Type",
      dataIndex: "type",
      sorter: (a, b) => {
        return a.type.localeCompare(b.type);
      },
      render: (text, record, index) => {
        if (!text) return <span>{text}</span>;
        if (text === "agency") {
          return <span> Legal Advisor</span>;
        }
        return <span> {text.charAt(0).toUpperCase() + text.slice(1)}</span>;
      },
    },
    {
      key: "3",
      title: "Number of Followers",
      dataIndex: "followers",
      sorter: (a, b) => {
        if (a.followers === undefined || b.followers === undefined) return;

        return a.followers - b.followers;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "left" }}>-</p>;
        return (
          <p>
            {Math.abs(text) > 999
              ? Math.sign(text) * (Math.abs(text) / 1000).toFixed(1) + "k"
              : Math.sign(text) * Math.abs(text)}
          </p>
        );
      },
    },
    {
      key: "4",
      title: "User ID",
      dataIndex: "user_id",
      sorter: (a, b) => {
        return a.user_id.localeCompare(b.user_id);
      },
    },
    {
      key: "5",
      title: "Creation Date",
      dataIndex: "date",
      sorter: (a, b) => {
        return a.date.localeCompare(b.date);
      },
    },
    {
      key: "6",
      title: "Email Address",
      dataIndex: "email_address",
      sorter: (a, b) => {
        return a.email_address.localeCompare(b.email_address);
      },
    },
    {
      key: "7",
      title: "Status",
      dataIndex: "status",
      sorter: (a, b) => {
        return a.status.localeCompare(b.status);
      },
      //
      filters: [
        { text: "Active - Validated", value: "active - validated" },
        { text: "Active - Unvalidated", value: "active - unvalidated" },
        { text: "Inactive - Unvalidated", value: "inactive - unvalidated" },
        { text: "Inactive - Validated", value: "inactive - validated" },
        { text: "Pending", value: "pending" },
        { text: "Deleted", value: "deleted" },
      ],
      onFilter: (record, value) => {
        let active;
        value.validated ? (active = "validated") : (active = "unvalidated");
        if (value.deleted) return record === "deleted";
        if (!value.loggedIn) return record === "pending";
        return `${value.status} - ${active}` === `${record}`;
      },
      render: (text, record, index) => {
        let style;
        if (record.status === "active" && record.validated === "true")
          style = { color: "#419F23" };
        else if (record.status === "inactive") style = { color: "#B20606" };
        else style = { color: "black" };
        let active;
        record.validated === "true"
          ? (active = "validated")
          : (active = "unvalidated");

        if (record.deleted) {
          return (
            <p
              style={{
                color: "red",
              }}
            >
              {"deleted".charAt(0).toUpperCase() + "deleted".slice(1)}
            </p>
          );
        } else if (!record.loggedIn) {
          return (
            <p
              style={{
                color: "black",
              }}
            >
              {text.charAt(0).toUpperCase() + text.slice(1)} &nbsp;-&nbsp;{" "}
              {"pending".charAt(0).toUpperCase() + "pending".slice(1)}
            </p>
          );
        }
        return (
          <p style={style}>
            {text.charAt(0).toUpperCase() + text.slice(1)}&nbsp;-&nbsp;
            {active.charAt(0).toUpperCase() + active.slice(1)}
          </p>
        );
      },
    },
    {
      key: "8",
      title: "Invited Users",
      dataIndex: "invited_users",
      sorter: (a, b) => {
        return a.invited_users - b.invited_users;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "center" }}>-</p>;
        else return <p>{text}</p>;
      },
    },
    {
      key: "9",
      title: "Subscribed Users",
      dataIndex: "subscribed_users",
      sorter: (a, b) => {
        return a.subscribed_users - b.subscribed_users;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "left" }}>-</p>;
        else return <p>{text}</p>;
      },
    },
    {
      key: "10",
      title: "Claimed Rewards",
      dataIndex: "claimed_rewards",
      disableSortBy: true,
      sorter: (a, b) => {
        return a.claimed_rewards - b.claimed_rewards;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "left" }}>-</p>;
        else return <p>{text}</p>;
      },
    },
    {
      key: "11",
      title: "Unclaimed Rewards",
      dataIndex: "unclaimed_rewards",
      sorter: (a, b) => {
        return a.unclaimed_rewards - b.unclaimed_rewards;
      },
      render: (text, record, index) => {
        if (text === undefined) return <p style={{ textAlign: "left" }}>-</p>;
        else return <p>{text}</p>;
      },
    },

    // eslint-disable-next-line react-hooks/exhaustive-deps
  ];

  useEffect(() => {
    fetch(`${base_url}admin/partners/data`, {
      method: "POST",
      mode: "cors",
      body: ``,
      titles: {
        Accept: "application/json, text/plain, */*",
        "Content-type": "application/x-www-form-urlencoded",
        credentials: "include",
      },
      credentials: "include",
    })
      .then((res) => res.json())
      .then((res) => {
        const data = res.data
          .sort((a, b) => {
            return b.date - a.date;
          })
          .map((user, i) => {
            return {
              ...user,
              date: dayjs(user.date).format("YYYY-MM-DD"),
              index: res.data.length - i,
            };
          });

        setData(data);
        setFilteredData(data);
        setTableLoading(false);
      })
      .catch((err) => {
        console.log(err);
      });

    return;
  }, []);
  // const getReferrals = (userId) => {
  //   fetch(base_url + "admin/partners/events/partner", {
  //     method: "POST",
  //     mode: "cors",
  //     credentials: "include",
  //     headers: {
  //       Accept: "application/json, text/plain, /",
  //       "Content-type": "application/x-www-form-urlencoded",
  //       credentials: "include",
  //     },
  //     body: `partner_id=${userId}`,
  //   })
  //     .then((res) => res.json())
  //     .then((res) => {
  //       console.log(res);
  //     });
  // };
  useEffect(() => {
    const filterTable = data.filter((o) =>
      Object.keys(o).some((k) =>
        String(o[k]).toLowerCase().includes(globalSearch.toLowerCase())
      )
    );
    setFilteredData(filterTable);
  }, [globalSearch]);
  const globalSearchFunction = (value) => {
    setGlobalSearch(value);
  };
  const handleOk = () => {
    setModalOpened(false);
  };
  const handleCancel = () => {
    setModalOpened(false);
  };
  const closeEditModal = () => {
    setOpenEditPartnerModal(false);
  };

  return (
    <>
      <TableFilter globalSearch={globalSearchFunction} />
      <Table
        className={styles.partnerDataTable}
        loading={tableLoading}
        onRow={(record, rowIndex) => {
          return {
            onClick: (e) => {
              if (e.target.dataset.openpopup === "no") return;
              setUserId(record.user_id);
              setModalOpened(true);
              setPopupData(record);
            },
          };
        }}
        rowClassName="td"
        columns={columns}
        dataSource={filteredData}
        pagination={{
          className: "partnerDataPagination",
          locale: { items_per_page: "" },
          pageSize: pageSize,
          current: page,
          showSizeChanger: true,
          total: data.length,
          onChange: (page, pageSize) => {
            setPage(page);
            setPageSize(pageSize);
          },
          showTotal: (total, range) => {
            return `Page ${page} of ${Math.ceil(total / pageSize)}`;
          },
          itemRender: (page, type, originalElement) => {
            if (type === "next") return <span>Next</span>;
            if (type === "prev") return <span>Previous</span>;
            if (type === "page") return null;
            return originalElement;
          },
        }}
        locale={{ items_per_page: "sds" }}
      ></Table>

      <EditPartnerForm
        userId={userId}
        onOk={closeEditModal}
        onCancel={closeEditModal}
        open={openEditPartnerModal}
        setData={setData}
        setFilteredData={setFilteredData}
        component={"edit"}
      />
      <EditPartnerForm
        onOk={closeAddPartnerModal}
        onCancel={closeAddPartnerModal}
        open={openAddNewPartner}
        component={"addPartner"}
        setData={setData}
        setFilteredData={setFilteredData}
      />

      <PartnerDataPopup
        data={popupData}
        handleOk={handleOk}
        handleCancel={handleCancel}
        modalOpened={modalOpened}
        userId={userId}
      />
    </>
  );
}

export default PartnersDataTable;
